<template>
  <a-popover
    ref="addReplyPopover"
    v-model="visible"
    trigger="click"
    placement="topRight"
    :auto-adjust-overflow="false"
    :destroy-tooltip-on-hide="true"
    overlay-class-name="addReplyPopover"
    :get-popup-container="
      triggerNode => {
        return triggerNode.parentNode || document.body;
      }
    "
    @visibleChange="visibleChange"
  >
    <div slot="content">
      <div class="msg">
        <span
          ref="truename"
          class="truename"
        >@{{ data.truename }}:</span>
        <a-input
          v-model="newMsg"
          type="textarea"
          :style="{'padding-left': data.trueNameWidth + 'px'}"
          @focus="onFocus"
        />
      </div>
      <div class="btns clearfix">
        <a-button
          type="primary"
          class="confirm-btn"
          :disabled="newMsg === ''"
          @click="handleComfirm"
        >
          {{ $t('message["449"]') }}
        </a-button>
      </div>
    </div>
    <a
      class="fs-blue"
      @click="clickReply"
    >
      {{ $t('message["449"]') }}
    </a>
  </a-popover>
</template>

<script>
export default {
  props: {
    /* btnText: {
      type: String,
      default: ''
    },
    cancleText: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: '确定'
    }, */
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visible: false,
      newMsg: '',
      top: ''
    }
  },

  methods: {
    clickReply () {
      this.setShowReplyTrueNameWidth(this.data)
    },
    setShowReplyTrueNameWidth (item) {
      setTimeout(() => {
        let trueNameWidth = this.$refs.truename && this.$refs.truename && this.$refs.truename.offsetWidth
        this.$set(this.data, 'trueNameWidth', trueNameWidth + 8)
        this.$forceUpdate()
      }, 30)
    },

    visibleChange (visible) {
      /* if (visible) {
        this.$nextTick(() => {
          let $ele = document.querySelector('.addReplyPopover')
          if ($ele) {
            this.top = parseInt($ele.style.top) + 2
            console.log('top', $ele.style.top, this.top)
            $ele.style.top = this.top + 'px'
          }
        })
      } */
    },
    onFocus (e) {
      e.preventDefault()
    },
    /* resetTop () {
      let $ele = document.querySelector('.addReplyPopover')
      if ($ele) {
        console.log($ele.style.top)
        $ele.style.top = this.top
      }
    }, */
    async handleComfirm () {
      let obj = Object.assign({}, this.data, { content: this.newMsg })
      this.$emit('submit', obj)
      this.visible = false
      this.newMsg = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.msg {
  position: relative;
  .truename {
    position: absolute;
    top: 5px;
    left: 8px;
    z-index: 2;
    color: #999;
  }
}
.confirm-btn {
  float: right;
  margin-top: 8px;
  &.ant-btn[disabled] {
    color: #fff;
    background: linear-gradient(
      360deg,
      rgba(80, 119, 170, 1) 0%,
      rgba(96, 143, 204, 1) 100%
    );
    box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(80, 119, 170, 1);
    opacity: 0.8;
  }
}
</style>
